/**
 * Contract Categories for Criminal Record Declaration
 * Matches the FormStack form dropdown options
 */
const ContractCategory = {
    CASUAL_AD_HOC: 1,
    SALARIED_FIELD_BASED: 2,
    SALARIED_MANAGEMENT: 3,
    I_DONT_KNOW: 4
};

export default ContractCategory;

export function getContractCategories() {
    return [
        {
            value: ContractCategory.CASUAL_AD_HOC,
            name: 'Casual/Ad-hoc worker'
        },
        {
            value: ContractCategory.SALARIED_FIELD_BASED,
            name: 'Salaried Employee (Field Based/Operations)'
        },
        {
            value: ContractCategory.SALARIED_MANAGEMENT,
            name: 'Salaried Employee (Management or Back of house services)'
        },
        {
            value: ContractCategory.I_DONT_KNOW,
            name: "I don't know"
        }
    ];
}

export function getContractCategoryString(value) {
    const categories = getContractCategories();
    const category = categories.find(c => c.value === value);
    return category ? category.name : '';
}
